import React from 'react';
import useStyles from 'apps/Pdf/components/common/styles/P';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const P = (props: Props) => {
  const classes = useStyles();
  const { children, className } = props;

  return <p className={`${classes.root}${className ? ' ' + className : ''}`}>{children}</p>;
};

export default P;
